import style from './Home.module.scss';
import { ReactComponent as MultiversXIcon } from 'src/assets/icons/multiversx.svg';
import { ReactComponent as EtherIcon } from 'src/assets/icons/ether.svg';
import { ReactComponent as RightArrowIcon } from 'src/assets/icons/arrow-right.svg';

import { ReactComponent as MultiversXProviderIcon } from 'src/assets/icons/provider-multiversx.svg';
import { ReactComponent as BscProviderIcon } from 'src/assets/icons/provider-bsc.svg';
import { ReactComponent as EgldTadaPoolIcon } from 'src/assets/icons/pool-egld-tada.svg';
import { ReactComponent as BnbTadaPoolIcon } from 'src/assets/icons/pool-bnb-tada.svg';
import { ReactComponent as XEchangeIcon } from 'src/assets/icons/xexchange.svg';
import { ReactComponent as PancakeSwapIcon } from 'src/assets/icons/pancakeswap.svg';
import { ReactComponent as RightUpArrowIcon } from 'src/assets/icons/arrow-up-right.svg';
import { StoreButton, UnderlineButton } from 'src/components/Button/Button';

import { ReactComponent as PlayStoreIcon } from 'src/assets/icons/playstore.svg';
import { ReactComponent as AppStoreIcon } from 'src/assets/icons/appstore.svg';
import { useState } from 'react';
import SignModal from 'src/components/SignModal/SignModal';
import { appStoreUrl, bscDepositPool, multiversXDepositPool, playstoreUrl } from 'src/config';
import { useNavigate } from 'react-router-dom';

const MODE = {
    MULTIVERSX: 'MULTIVERSX',
    BSC: 'BSC',
};

function Home() {
    const navigate = useNavigate();
    const [signModalMode, setSignModalMode] = useState(null);

    return (
        <div className={style.home}>
            <div className={style.redeemPanel}>
                <div className={style.content}>
                    <strong>Redeem my NFTs</strong>
                    <span>
                        Check your eligible rewards and redeem your NFTs directly from the web portal.
                        Connect your wallet to start claiming your rewards!
                    </span>
                    <button onClick={() => navigate('/rewards')}>
                        View My Rewards <RightArrowIcon />
                    </button>
                </div>
                <img 
                    src="/assets/images/mesh.png" 
                    alt="" 
                    className={style.meshBackground}
                />
            </div>
            <div className={style.linkPortal}>
                <div className={style.top}>
                    <div className={style.header}>
                        <strong>Welcome to the Tada wallet connection portal!</strong>
                        <span>
                            This portal allows you to connect your wallets and sync them with the TADA mobile app.​
                        </span>
                    </div>
                    <div className={style.certification}>
                        <span>Audited by</span>
                        <img src="/assets/images/certification.png" alt="Certik / Arda auditers" />
                    </div>
                </div>
                <div className={style.bottom}>
                    <div className={style.illustration}>
                        <img src="/assets/images/link-wallet-illustration.png" alt="TADA link app" />
                    </div>
                    <div className={style.links}>
                        <strong>Link Wallets</strong>
                        <span>
                            Link wallets you use to stake or provide liquidity with your $TADA tokens to enjoy exclusive
                            in-app bonuses and increased earnings.
                        </span>

                        <div className={style.buttons}>
                            <button onClick={() => setSignModalMode(MODE.MULTIVERSX)}>
                                <MultiversXIcon /> MultiversX Wallet <RightArrowIcon />
                            </button>
                            <button onClick={() => setSignModalMode(MODE.BSC)}>
                                <EtherIcon /> EVMs Wallet <RightArrowIcon />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            

            <div className={style.pools}>
                <strong>Welcome to the Tada wallet connection portal!</strong>
                <span>This portal allows you to connect your wallets and sync them with the TADA mobile app </span>

                <div className={style.pool}>
                    <XEchangeIcon />
                    <div className={style.caption}>
                        <i>Provider</i>
                        <span>xExchange</span>
                    </div>

                    <div className={style.repartition}>
                        <EgldTadaPoolIcon />

                        <div>
                            <span>EGLD/TADA</span>
                            <i>
                                <MultiversXProviderIcon />
                                MultiversX
                            </i>
                        </div>
                    </div>

                    <UnderlineButton href={multiversXDepositPool} endContent={<RightUpArrowIcon />}>
                        Deposit
                    </UnderlineButton>
                </div>
                <div className={style.pool}>
                    <PancakeSwapIcon />
                    <div className={style.caption}>
                        <i>Provider</i>
                        <span>Pancakeswap</span>
                    </div>

                    <div className={style.repartition}>
                        <BnbTadaPoolIcon />

                        <div>
                            <span>WBNB/TADA</span>
                            <i>
                                <BscProviderIcon />
                                BNB Smart Chain
                            </i>
                        </div>
                    </div>

                    <UnderlineButton href={bscDepositPool} endContent={<RightUpArrowIcon />}>
                        Deposit
                    </UnderlineButton>
                </div>
            </div>

            <div className={style.joinUs}>
                <img src="/assets/images/join-us-illustration.png" alt="Join us illustration" />

                <div className={style.content}>
                    <strong>Join us and start earning $TADA today!</strong>
                    <span>
                        Anyone can earn money with Ta-da, no special skills required. Complete small, fun tasks like
                        recording your voice, taking pictures, annotating images, engage with social media accounts, and
                        more. Get rewarded for your time!
                    </span>

                    <div className={style.stores}>
                        <StoreButton href={playstoreUrl}>
                            <PlayStoreIcon />
                        </StoreButton>
                        <StoreButton href={appStoreUrl}>
                            <AppStoreIcon />
                        </StoreButton>
                    </div>
                </div>
            </div>

            {signModalMode && <SignModal currentProvider={signModalMode} onClose={() => setSignModalMode(null)} />}
        </div>
    );
}

export default Home;
